import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';
import { DateStyles } from '../../constants/CentricConstants';
import { ModuleDialogs } from '../../constants/Dialogs';
import { formatName } from "../../utils/StringUtils";
import { Link } from "react-router";

import DetailView from '../Common/DetailView';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import RegistrationHistoryList from './RegistrationHistoryList';
import ModuleEnrolmentDialog from './ModuleEnrolmentDialog';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';

import ModuleActions from '../../actions/ModuleActionCreator';

import DialogActions from '../../actions/DialogActionCreator';
import ModuleSubscriptionStore from '../../stores/ModuleSubscriptionStore';
import ModuleEventStore from '../../stores/ModuleEventStore';
import { getNextStatuses } from '../../stores/ModuleStore';

import buildContextMenu from '../Common/BuildContextMenu';
import ROLES from '../../constants/Roles';

class ModuleEnrolment extends Component {
    componentWillMount() {
        ModuleActions.getSubscription(this.props.moduleId, this.props.userId);
        ModuleActions.getEvents(this.props.moduleId);
    }


    render() {
        return (
            <DetailView
                actions={buildContextMenu(this.getMenuItems(), this.context.auth)}
                backButton
            >
                <div className='cent-cards'>
                    <Card className="cent-card" style={{width: '100%'}}>
                        <CardHeader title="Enrolment details" />
                        <CardText className="cent-card-text">
                            <div className='cent-flex-row'>
                                <div className='cent-col-2'>
                                    <ul className="cent-list-plain">
                                        <li><em>Name: </em>
                                            <Link to={`/dashboard/user/${this.props.userId}`}>{formatName(this.state.details)}</Link>
                                        </li>
                                        <li><em>Module: </em>
                                            <Link to={`/dashboard/module/${this.props.moduleId}`}>{this.state.details.module}</Link>
                                        </li>
                                        <li><em>Requirement: </em>{!!this.state.details.isMandatory ? 'Mandatory' : 'Optional'}</li>
                                        <li><em>Method: </em>{!!this.state.details.isAssigned ? `assigned${!!this.state.details.assignedBy ? ` (${this.state.details.assignedBy})` : ''}` : 'self-enrolled'}</li>
                                        <li><em>Status: </em>{this.state.details.status}</li>
                                    </ul>
                                </div>
                                <div className='cent-col-2'>
                                    <ul className="cent-list-plain">
                                        <li><em>Enrolled: </em>
                                            {this.state.details.dateAdded && new Date(this.state.details.dateAdded).toLocaleString('en-GB', DateStyles.shortDateTime)}
                                        </li>
                                        <li><em>Completed: </em>
                                            {this.state.details.dateCompleted && new Date(this.state.details.dateCompleted).toLocaleString('en-GB', DateStyles.shortDateTime)}
                                        </li>
                                        <li><em>Score: </em>{this.state.details.score}</li>
                                    </ul>
                                </div>
                            </div>
                        </CardText>
                    </Card>
                    <RegistrationHistoryList userId={this.props.userId} moduleId={this.props.moduleId}/>
                </div>
                <ModuleEnrolmentDialog
                    onSave={(draft) => ModuleActions.saveSubscription(this.props.moduleId, this.props.userId, draft, this.state.details)}
                    title="Edit enrolment"
                    moduleId={this.props.moduleId}
                    events={this.state.events}
                />
            </DetailView>
        );
    }

    getMenuItems() {
        return [
            {
                action: () => DialogActions.open(ModuleDialogs.ENROLMENT_EDIT, {
                    ...this.state.details,
                    ...{
                        dateCompleted: !!this.state.details.dateCompleted ? new Date(this.state.details.dateCompleted) : null,
                        events: this.state.events,
                        currentEvent: this.state.details.eventId,
                        statuses: getNextStatuses(this.state.details.status)
                    }
                }),
                icon: <EditIcon/>,
                label: 'Edit enrolment',
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
        ];
    };
}

ModuleEnrolment.getStores = () => ([ModuleSubscriptionStore]);
ModuleEnrolment.calculateState = (prevState, {moduleId, userId}) => ({
    details: ModuleSubscriptionStore.getSubscription(moduleId, userId) || {},
    events: ModuleEventStore.getByModule(moduleId) || {}
});
ModuleEnrolment.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default Container.create(ModuleEnrolment, {withProps: true});
